import { createSlice } from "@reduxjs/toolkit";
import { InitialPlasticStockFormData } from "../../ConstantData/InitialData";
import { InitialPlasticStockDuplicateFormData } from "../../ConstantData/InitialDuplicateData";
const plasticStockSlice = createSlice({
  name: "plasticstock",
  initialState: {
    plasticStockList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    billList: [],
    // billDataList: {},
    initialData: InitialPlasticStockFormData,
    initialDuplicateData: InitialPlasticStockDuplicateFormData,
  },
  reducers: {
    getAllPlasticStocks: (state, action) => {
      state.plasticStockList = action.payload;
    },
    getPlasticStockDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialPlasticStockFormData };
    },
    setDuplicateInitialData: (state) => {
      state.initialDuplicateData = { ...InitialPlasticStockDuplicateFormData };
    },
    getBillList: (state, action) => {
      if (action.payload.data.length <= 0) {
        state.initialDuplicateData = [];
      }
      state.billList = action.payload.data;
    },
    getDataUsingBill: (state, action) => {
      state.initialDuplicateData = action.payload.data;
      state.dataEdit = action.payload.editData;
    },
    adjustPlasticStockItem: (state, action) => {},
    deletePlasticStock: () => {},
  },
});

export const plasticStockSliceAction = plasticStockSlice.actions;
export default plasticStockSlice.reducer;
